export const WORKSPACE_STATES=[
 ['default','Обычный кабинет',''],
 ['locked','Предупреждение о заблокированных средствах','dashboard'],
 ['no-assets','Нет доступных валют','dashboard'],
 ['rates-live','Текущие курсы','dashboard'],
 ['rates-stale','Сохранённые курсы','dashboard'],
 ['progress','Продвижение дела и проверка завершена','dashboard'],
 ['records','Операции и запросы: все статусы','transactions'],
 ['verification-pending','Документы: ожидают проверки','kyc'],
 ['verification-approved','Документы: одобрены','kyc'],
 ['verification-rejected','Документы: отклонены','kyc'],
 ['portfolio','Окно портфеля','dashboard'],
 ['receive','Получение: адрес задан','dashboard'],
 ['receive-empty','Получение: адрес не задан','dashboard'],
 ['qr-error','Ошибка QR-кода','dashboard'],
 ['deposit','Окно пополнения','dashboard'],
 ['withdraw','Окно вывода','dashboard'],
 ['contact','Окно сообщений','dashboard'],
 ['upload','Добавление документа','evidence'],
 ['validation','Ошибка заполнения формы','dashboard'],
 ['toast','Всплывающее уведомление','dashboard'],
];
